import React, {useEffect, useState} from 'react'

// MODULES
import { Routes, Route, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {io} from 'socket.io-client'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import Customization from "./components/settings/Settings";
import NotificationBox from './components/notificationBox/NotificationBox';
import MessageBox from "./components/messageBox/MessageBox";

// API
import { ipAccess } from './api';

// IMAGES
import avatar from './assets/profile.png'

// STATE MANAGEMENT
import {handleAddMessages} from './state/chatSlice'
import {handleAddNotifications} from './state/userSlice'

// GENERAL PAGES
import Auth from "./pages/auth/Auth";
import Home from "./pages/home/Home";
import LeaveRequest from "./pages/leaveRequest/LeaveRequest";
import RequestStatus from "./pages/requestStatus/RequestStatus";
import Attendance from './pages/attendance/Attendance'
import Todo from './pages/todo/Todo'
import Report from './pages/report/Report'
import StaffHandBook from './pages/staffHandBook/StaffHandBook'
import NewsStand from './pages/newsStand/NewsStand'
import Appraisal from './pages/appraisal/Appraisal'
import AppraisalTracker from './pages/appraisalTracker/AppraisalTracker'
import ChatRoom from './pages/chatRoom/ChatRoom'
import Email from './pages/email/Email'
import Ticket from './pages/ticket/Ticket'
import Profile from "./pages/profile/Profile";
import AllActivities from "./pages/allActivities/AllActivities";
import ForgotPassword from './pages/forgotPassword/ForgotPassword';
import ResetPassword from './pages/resetPassword/ResetPassword';
import Verification from './pages/verification/Verification';
import Access from './pages/access/Access';

// HR PAGES
import Employee from "./pages/hr/employees/Employee";
import Department from "./pages/hr/department/Department";
import Payroll from "./pages/hr/payroll/Payroll";
import Resignation from "./pages/hr/resignation/Resignation";
import Termination from "./pages/hr/termination/Termination";
import Payslip from "./pages/hr/payroll/Payslip";
import AppraisalTable from "./pages/hr/appraisal/AppraisalTable";
import UpdateAppraisal from "./pages/hr/appraisal/UpdateAppraisal";
import StaffAttendance from "./pages/hr/attendances/Attendance";
import Holiday from "./pages/hr/holiday/Holiday";
import Todolist from "./pages/hr/todolist/Todolist";
import StaffReports from "./pages/hr/reports/Reports";
import UserRequestStatus from "./pages/hr/requestStatus/RequestStatus";

// ADMINISTRATOR
import Settings from './pages/Administrator/settings/Settings';
import UpdateTicket from './pages/ticket/UpdateTicket';


// const socket = io.connect('http://localhost:8080')
const socket = io.connect('https://aspom-server.onrender.com')
// const socket = io.connect('https://backend.aspomportal.com')


// PROFILE MODAL
const ProfileModal = ({user})=>{
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 5000); // Show modal after 5 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    localStorage.setItem('profileUpdateModalDismissed', 'true');
  };

  const handleNavigate = () => {
    setShowModal(false);
    localStorage.setItem('profileUpdateModalDismissed', 'true');
    navigate('/profile')
  };

  if (!showModal) {
    return null;
  }

  return(
    <div className='profile__modal' onClick={handleCloseModal}>
      <div className='profile__modal-box' onClick={(e)=>e.stopPropagation()}>
        <img src={!user?.profilePic ? avatar
          : `https://aspom-server.onrender.com/upload/${user?.profilePic}`}
          alt="Avatar" className="profile__modal-img"/>
        <span className="profile__modal-name">Welcome back <b>{user?.firstName}</b></span>
        <h2 className="profile__modal-title">Update Your Profile</h2>
        <p className="profile__modal-text">Please take a moment to update your profile to ensure 
          that your information is accurate and up-to-date. <b>Thank you!</b>
        </p>
        <div className='profile__modal-buttons'>
          <button onClick={handleCloseModal}
          className="profile__modal-btn">
            Cancel
          </button>
          <button onClick={handleNavigate}
          className="profile__modal-btn">
            Update Now
          </button>
        </div>
      </div>
    </div>
  )
}

// LAYOUT
const Layout = ({message, showProfileUpdateModal})=>{
  const location = useLocation()
  const {user} = useSelector((state)=>state.user)
  const {selectTheme, notification, 
    notifyMessage, settings, sidebar} 
    = useSelector((state)=>state.settings)

  return user?.token ? <div className={`app ${!sidebar && 'active'}`}
  data-theme={selectTheme}>
    <Sidebar/>
    <Topbar message={message}/>
    {notification && <NotificationBox/>}
    {notifyMessage && <MessageBox/>}
    {settings && <Customization/>}
    {showProfileUpdateModal && <ProfileModal user={user}/>}
    <main>
      <ToastContainer/>
      <Outlet/>
    </main>
  </div> 
  : <Navigate to='/auth' state={{from : location}} replace />
}

function App() {
  const [showProfileUpdateModal, setShowProfileUpdateModal] = useState(false);
  const {user} = useSelector((state)=>state.user)
  const {message} = useSelector((state)=>state.chat)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [audio] = useState(new Audio('/notify_tone.mp3'));


  useEffect(() => {
    const modalDismissed = localStorage.getItem('profileUpdateModalDismissed');
    if (!modalDismissed) {
      setShowProfileUpdateModal(true);
    }
  }, []);


  // NOTIFICATION SOUND
  const playAudio = () =>{
    audio.play().catch(error => {
      console.error('Failed to play audio:', error);
    });
  }

  // CONNECT TO SOCKET
  useEffect(()=>{
    socket.emit('new-user', user?._id)
    socket.on('get-users', (socketUsers)=>{
        // console.log('This are the connected users', socketUsers)
    })
  },[])

  // RECEIVE MESSAGE FROM SOCKET
  useEffect(()=>{
    socket.on('receive-message', (data)=>{
      dispatch(handleAddMessages(data))
      playAudio()
      showNotification('New Message', 'You have received a new message.');
    })

    // Listen for notifications event
    socket.on('receive-notification', (data) => {
      dispatch(handleAddNotifications(data));
      playAudio()
      showNotification('New Notification', 'You have received a new notification.');
    });

    // return () => {
    //   socket.off('receive-message');
    //   socket.off('receive-notification');
    // };

  },[])

  // Fetch user's IP address
const fetchIPAddress = async () => {
  try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      const ipAddress = data.ip;
      // Send IP address to backend
      sendIPAddressToBackend(ipAddress);
  } catch (error) {
      console.error('Error fetching IP address:', error);
  }
};

// Send user's IP address to backend
const sendIPAddressToBackend = async (ipAddress) => {
  try {
      // const response = await fetch('https://backend.aspomportal.com/access-location', {
      const response = await fetch('https://aspom-server.onrender.com/access-location', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ipAddress }),
      });
      const data = await response.json();
      if(!data?.access){
        navigate('/auth/access-denied')
        localStorage.setItem('access', 'false')
      }
      // Redirect user or display dashboard based on location
  } catch (error) {
      console.error('Error sending IP address to backend:', error);
  }
};

// Call fetchIPAddress when the component mounts
useEffect(() => {
  fetchIPAddress();
}, []);


  // Function to display notification
  const showNotification = (title, body) => {
    if (Notification.permission === 'granted') {
      new Notification(title, { body });
    }
  };
  
  return (
    <>
      <Routes>
        {/* AUTHENTICATION ROUTE */}
        <Route path="/auth" element={<Auth />} />
        <Route path="/auth/access-denied" element={<Access />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/reset-password/:id/:token" element={<ResetPassword />} />
        <Route path="/auth/verification/:id" element={<Verification />} />

        {/* MAIN ROUTE */}
        <Route element={<Layout message={message} 
        showProfileUpdateModal={showProfileUpdateModal}/>}>

          {/* GENERAL ROUTE */}
          <Route path="/" element={<Home socket={socket}/>}/>
          <Route path="/staff_hand_book" element={<StaffHandBook/>}/>
          <Route path="/news_stand" element={<NewsStand socket={socket}/>}/>
          <Route path="/attendance" element={<Attendance/>}/>
          <Route path="/todo_list" element={<Todo/>}/>
          <Route path="/end_of_day_report" element={<Report/>}/>
          <Route path="/chat_room/:queryId?" element={<ChatRoom socket={socket}/>}/>
          <Route path="/appraisal_tracker" element={<AppraisalTracker/>}/>
          <Route path="/email" element={<Email/>}/>
          <Route path="/ticket" element={<Ticket/>}/>
          <Route path="/ticket/:ticketId" element={<UpdateTicket/>}/>
          <Route path="/profile/:id?" element={<Profile/>}/>
          <Route path="/activities" element={<AllActivities/>}/>
          <Route path="/leave_request" element={<LeaveRequest/>}/>
          <Route path="/leave_request_status" element={<RequestStatus/>}/>
          <Route path="/submit_appraisal" element={<Appraisal/>}/>

          {/* ADMINISTRATOR ROUTE */}
          <Route path="/settings" element={<Settings/>}/>

          {/* HR PORTAL ROUTES */}
          <Route path="/employees" element={<Employee/>}/>
          <Route path="/department" element={<Department/>}/>
          <Route path="/staff__attendance" element={<StaffAttendance/>}/>
          <Route path="/appraisal" element={<AppraisalTable/>}/>
          <Route path="/appraisal/:id" element={<UpdateAppraisal/>}/>
          <Route path="/staff__todolist" element={<Todolist/>}/>
          <Route path="/staff__reports" element={<StaffReports/>}/>
          <Route path="/payroll" element={<Payroll/>}/>
          <Route path="/holiday" element={<Holiday/>}/>
          <Route path="/payroll/payslip/:id" element={<Payslip/>}/>
          <Route path="/resignation" element={<Resignation/>}/>
          <Route path="/termination" element={<Termination/>}/>
          <Route path="/employees_leave_request" element={<UserRequestStatus/>}/>
          
        </Route>
      </Routes>
    </>
  );
}

export default App;
